import React from 'react'
import PropTypes from 'prop-types'

const Loading = ({ visible }) => {
  return visible
    ? <div className={'Loading'}>Loading, please wait...</div>
    : null
}

Loading.propTypes = {
  visible: PropTypes.bool
}

export default Loading
